module.exports = __webpack_public_path__ + "static/media/red.63226b2b.png";